<div class="cd-intragroup-transfer-checkbox">
  @if (formControl) {
  <div>
    <cds-checkbox [formControl]="formControl" ngDefaultControl></cds-checkbox>
  </div>
  }
  <div class="l-ml-4">
    <span class="cds-body2">{{ 'intra-group-transfer' | lang }}</span>
  </div>
</div>
